import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import { Redirect } from 'react-router-dom';
import { useMount } from 'react-use';
import { useAuthenticate, useTranslations } from '@ibe/tupvid-components';
import Keys from '../../Translations/generated/Logout.en.json.keys';
import fallback from '../../Translations/generated/Logout.en.json';
import MaxWidth from '../../Layouts/MaxWidth';
import PageUrl from '../../Models/PageUrl';
import BlankPageLayout from '../../Layouts/BlankPageLayout';

const Logout = observer(() => {
  const { authenticateService, removeToken } = useAuthenticate();

  const { t } = useTranslations('Logout', fallback);

  const [dots, setDots] = useState('.');

  useMount(() => {
    (async (): Promise<void> => {
      await removeToken();
      await authenticateService.invalidate();
    })();
  });

  useEffect(() => {
    const loop = setInterval(() => {
      setDots(`${dots}.`);
    }, 1000);

    return (): void => clearInterval(loop);
  }, [dots]);

  if (dots === '....') {
    return <Redirect to={PageUrl.LOGIN} />;
  }

  return (
    <BlankPageLayout>
      <MaxWidth>
        <h1>{t(Keys.headline).toString()}</h1>
        <p>{`${t(Keys.redirecting)} ${dots}`}</p>
      </MaxWidth>
    </BlankPageLayout>
  );
});

export default Logout;
